import apiCaller from '../http';
import URLS from '../urls';

const fetchUserProfile = async (profileId, action) => {
  await apiCaller
    .get(`${URLS.PROFILE}${profileId}/`)
    .then((response) => {
      action(response?.data);
    })
    .catch(() => {
      action(null);
    });
};

export default fetchUserProfile;
